import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { LegendItemComponent, LegendItemComponentProps } from "../LegendItemComponent/LegendItemComponent";

type StateProps = Pick<LegendItemComponentProps, "legendItemHeaderText" | "legendItemDescriptionText">;

export type LegendItemProps = {
    /** lokalizační klíč pro text předávaný header */
    readonly legendItemHeaderLocKey: string;
    /** lokalizační klíč pro text předávaný description */
    readonly legendItemDescriptionLocKey: string;
};

const mapStateToProps: MapStateToProps<StateProps, LegendItemProps, IAppState> = (state, { legendItemHeaderLocKey, legendItemDescriptionLocKey }) => ({
    legendItemHeaderText: getPrimaryText(state, legendItemHeaderLocKey) ?? "",
    legendItemDescriptionText: getPrimaryText(state, legendItemDescriptionLocKey) ?? "",
});

export const LegendItem = connect(mapStateToProps)(LegendItemComponent);
